import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import MindsetsJsSDK, {
    accessConstants,
    authUtils,
    Checkbox,
    LoadCurriculaAction, SuccessMessageAction, ErrorMessageAction
} from "mindsets-js-sdk";

import NoAccess from "../../common/NoAccess";

export default function () {
    const me = useSelector(state => state.me);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const selected_challenge_resource_ids = useSelector(state => state.selected_challenge_resource_ids);
    const curricula_all = useSelector(state => state.curricula);
    const [curricula, setCurricula] = useState(null);

    useEffect(() => {
        dispatch(LoadCurriculaAction());

        return () => {
            setCurricula(null);
        };
    }, []);

    function onSubmit() {
        MindsetsJsSDK().API
            .put('challenge_resources/update', {
                resource_ids: selected_challenge_resource_ids,
                curricula
            })
            .then(() => {
                dispatch(SuccessMessageAction('Selected Resources have been updated.'));
                navigate(-1);
            })
            .catch(error => {
                dispatch(ErrorMessageAction(error));
                console.error(error);
            });
    }

    if (!me) {
        return null;
    }
    if (authUtils.iCant(me, [accessConstants.PERMISSION_CAN_MANAGE_CHALLENGES])) {
        return (
            <NoAccess/>
        );
    }

    return (
        <div className='container section'>
            <title>Update Resources</title>
            <h1>Update Selected Resources in bulk</h1>

            <div className='section'>
                <label>Curricula</label>
                <div className='d-flex flex-gap-5 flex-wrap'>
                    {curricula_all.map(curriculum => {
                        return (
                            <Checkbox
                                key={curriculum.id}
                                checked={Array.isArray(curricula) && curricula.includes(curriculum.code)}
                                toggle={() => {
                                    if (Array.isArray(curricula)) {
                                        const curricula_new = JSON.parse(JSON.stringify(curricula));
                                        if (curricula_new.includes(curriculum.code)) {
                                            curricula_new.splice(curricula_new.indexOf(curriculum.code), 1);
                                        } else {
                                            curricula_new.push(curriculum.code);
                                        }
                                        if (curricula_new.length > 0) {
                                            setCurricula(curricula_new);
                                        } else {
                                            setCurricula(null);
                                        }
                                    } else {
                                        setCurricula([curriculum.code]);
                                    }
                                }}
                                label={curriculum.name}/>
                        );
                    })}
                </div>
            </div>

            <div className='section d-flex flex-gap-10'>
                <button onClick={onSubmit}>Submit</button>
                <button className="button default" onClick={() => navigate(-1)}>Cancel</button>
            </div>
        </div>
    );
}
